import { ChecklistOutlined } from '@mui/icons-material'
import { Button, Typography } from '@mui/material'
import { useBomItemIssueDescription } from 'features/BillOfMaterials/components/useBomItemIssueDescription'
import { useBomItemDetailsDialog } from 'features/BomItemDetailsDialog/useBomItemDetailsDialog'
import { BomItemPointer } from 'model/Project/BomItemPointer'
import { IssueDto } from 'services/APIs/InternalAPI/internal-api.contracts'

type Props = {
  bomItemPointer: BomItemPointer
  issue: IssueDto
}

export const EstimatedProductionTimeIsZeroTodo = (props: Props) => {
  const openBomItemDetailsDialog = useBomItemDetailsDialog()

  const { getIssueDescription } = useBomItemIssueDescription()

  return (
    <Button
      component={'li'}
      style={{
        display: 'flex',
        gap: '1rem',
        alignItems: 'center',
        justifyContent: 'flex-start',
      }}
      onClick={() =>
        openBomItemDetailsDialog('financials', {
          bomItemPointer: props.bomItemPointer,
        })
      }
      color="inherit"
      startIcon={<ChecklistOutlined />}
    >
      <Typography variant="body2">
        {getIssueDescription(props.issue)}
      </Typography>
    </Button>
  )
}
